import { render, staticRenderFns } from "./FilesContainerNew.vue?vue&type=template&id=b3132526&scoped=true"
import script from "./FilesContainerNew.vue?vue&type=script&lang=js"
export * from "./FilesContainerNew.vue?vue&type=script&lang=js"
import style0 from "./FilesContainerNew.vue?vue&type=style&index=0&id=b3132526&prod&lang=css"
import style1 from "./FilesContainerNew.vue?vue&type=style&index=1&id=b3132526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3132526",
  null
  
)

export default component.exports